import { useEffect, useState } from "react";
import { Card, Button, Form } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import "./style.css";
import api from "../../../../services/api";
import AlertMessage from "../../../Alert";
import { Load } from "../../../Load";
import InputMask from "react-input-mask";
import { IdMP } from "../../../Icons";

const AsoValidarInfoReaproveitamento = () => {
	const navigate = useNavigate();
	const [isDisabled, setIsDisabled] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [alert, setAlert] = useState({
		show: false,
		message: "",
		variant: "success",
	});
	const { idConsulta } = useParams();
	const [etapa, setEtapa] = useState(0);
	const [cadastro, setCadastro] = useState({
		id: null,
		nome: "",
		cpf: "",
		rg: "",
		data_nascimento: "",
		celular: "",
		sexo: "",
		email: "",
		versoDocumento: "",
		telefone: "",
		password: "",
		emailValidado: false,
		versoDocumentoValidado: false,
		telefoneValidado: false,
		passwordValidada: false,
	});

	useEffect(() => {
		const fetchInfoWorker = async () => {
			try {
				const response = await api.get(
					`buscar-trabalhador-reaproveitamento/${idConsulta}`,
				);
				return response.data;
			} catch (error) {
				console.error(error);
				setAlert({
					show: true,
					message: "Erro ao buscar informações do trabalhador",
					variant: "danger",
				});
			}
		};

		// Buscar dados do trabalhador ao carregar o componente
		const getDados = async () => {
			try {
				const dados = await fetchInfoWorker();
				setCadastro((prev) => ({
					...prev,
					...dados,
				}));
			} catch (error) {
				// Tratar erro, mostrar mensagem de alerta, etc.
			}
		};

		getDados();
	}, [idConsulta]);

	const validarInfo = async () => {
		try {
			setIsLoading(true);

			const dataPayload = {
				id: cadastro.id,
				nome: cadastro.nome,
				cpf: cadastro.cpf,
				celular: cadastro.celular,
				rg: cadastro.rg,
				data_nascimento: cadastro.data_nascimento,
				sexo: cadastro.sexo,
			};

			const response = await api.post("validar-info-trabalhador", dataPayload);

			if (response.status === 200) {
				navigate(`/aso/reaproveitamento/assinatura-facial/${idConsulta}`);
			} else {
				setAlert({
					show: true,
					message: "Erro ao validar informações",
					variant: "danger",
				});
			}
		} catch (error) {
			console.error(error);
			setAlert({
				show: true,
				message: "Erro ao validar informações",
				variant: "danger",
			});
		} finally {
			setIsLoading(false);
		}
	};

	const handleCardClick = (redirect: any) => {
		if (redirect === "id") {
			setEtapa(1);
		}
	};

	const handleVoltarAoGeral = () => {
		if (
			!cadastro.nome ||
			!cadastro.cpf ||
			!cadastro.celular ||
			!cadastro.rg ||
			!cadastro.data_nascimento ||
			!cadastro.sexo
		) {
			setAlert({
				show: true,
				message: "Todos os campos devem ser preenchidos.",
				variant: "danger",
			});
			return;
		}
		setIsDisabled(true);
		setEtapa(0);
	};

	const cardItem = ({
		className,
		icon,
		title,
		subTitle,
		btnText,
		cardActive,
		redirect,
		onCardClick,
	}: any) => (
		<Card
			className={`mb-1 card-item ${className} ${cardActive === "condition1" ? "card-active" : ""}`}
			style={{ height: "91px" }}
		>
			<Card.Body className="d-flex align-items-center justify-content-between card-body-mob-padding">
				{icon === "id" && (
					<div
						className={`${!cadastro.versoDocumento ? "icon-mp" : "icon-mp-valid"}`}
					>
						<IdMP />
					</div>
				)}
				<div className="valid-card-group" style={{ flex: 1 }}>
					<Card.Text className="card-text-title-normal-size card-text-title-mob-size">
						{title}
					</Card.Text>
					<Card.Text className="text-muted card-text-subtitle-normal-size card-text-subtitle-mob-size">
						{subTitle}
					</Card.Text>
				</div>
				{cardActive === "condition1" ? (
					<Button
						variant="primary"
						className="aso-btn-mp"
						onClick={onCardClick}
					>
						{btnText}
					</Button>
				) : null}
			</Card.Body>
		</Card>
	);

	const isContinueButtonEnabled = () => {
		return cadastro.versoDocumentoValidado;
	};

	return (
		<>
			<Load isLoading={isLoading} />
			{!isLoading && (
				<div className="background background-vi-desktop background-mobile">
					<div className="container" style={{ maxWidth: "500px" }}>
						{etapa === 0 && (
							<Card style={{ width: "100%" }}>
								<Card.Body className="card-body-vi-desktop card-body-mobile">


									<Card.Text
										style={{
											textAlign: "center",
											padding: "10px",
											fontSize: "14px",
										}}
									>
										Antes da assinatura, é necessária a validação dos seus dados
									</Card.Text>
									{!isDisabled && (
										<div className="mt-3">
											{cardItem({
												className: !cadastro.versoDocumento
													? "card-add"
													: "card-valid",
												icon: "id",
												title: "Validação de informações",
												subTitle: cadastro.versoDocumentoValidado
													? "Dados validados"
													: "Valide seus dados",
												btnText: "Validar",
												cardActive: !cadastro.versoDocumento
													? "condition1"
													: cadastro.versoDocumentoValidado
														? "condition2"
														: null,
												redirect: "id",
												onCardClick: () => handleCardClick("id"),
											})}
										</div>
									)}
									<div>
										{etapa === 0 && (
											<div className="d-flex justify-content-center mt-3">
												<Button
													variant="primary"
													className=""
													onClick={validarInfo}
													disabled={!isContinueButtonEnabled()}
												>
													Continuar
												</Button>
											</div>
										)}
									</div>
								</Card.Body>
							</Card>
						)}
						{etapa === 1 && (
							<Card style={{ width: "100%" }}>
								<Card.Body className="card-body-vi-desktop card-body-mobile">
									<Card.Title
										style={{
											textAlign: "center",
											padding: "10px",
											fontSize: "22px",
											fontWeight: "600",
											marginBottom: "0",
										}}
									>
										Validação de informações
									</Card.Title>
									<Card.Text
										style={{
											textAlign: "center",
											padding: "10px",
											fontSize: "14px",
										}}
									>
										Valide as informações cadastradas
									</Card.Text>
									<div className="mt-3">
										<Form.Group
											controlId="nomeTrabalhador"
											className="custom-form-group"
										>
											<Form.Label className="custom-label">
												Nome completo
											</Form.Label>
											<Form.Control
												type="text"
												value={cadastro.nome}
												onChange={(e) =>
													setCadastro({ ...cadastro, nome: e.target.value })
												}
											/>
										</Form.Group>

										<Form.Group controlId="cpf" className="custom-form-group">
											<Form.Label className="custom-label">CPF</Form.Label>
											<InputMask
												mask="999.999.999-99"
												value={cadastro.cpf}
												onChange={(e: any) =>
													setCadastro({ ...cadastro, cpf: e.target.value })
												}
											>
												{() => <Form.Control type="text" />}
											</InputMask>
										</Form.Group>

										<Form.Group controlId="rg" className="custom-form-group">
											<Form.Label className="custom-label">RG</Form.Label>
											<InputMask
												mask="99.999.999-9"
												value={cadastro.rg}
												onChange={(e: any) =>
													setCadastro({ ...cadastro, rg: e.target.value })
												}
											>
												{() => <Form.Control type="text" />}
											</InputMask>
										</Form.Group>

										<Form.Group
											controlId="dataNascimento"
											className="custom-form-group"
										>
											<Form.Label className="custom-label">
												Data de Nascimento
											</Form.Label>
											<Form.Control
												type="date"
												value={
													cadastro.data_nascimento
														? new Date(cadastro.data_nascimento)
																.toISOString()
																.split("T")[0]
														: ""
												} // Converter para 'YYYY-MM-DD'
												onChange={(e) =>
													setCadastro({
														...cadastro,
														data_nascimento: e.target.value,
													})
												}
											/>
										</Form.Group>

										<Form.Group
											controlId="celular"
											className="custom-form-group"
										>
											<Form.Label className="custom-label">Celular</Form.Label>
											<InputMask
												mask="(99) 99999-9999"
												value={cadastro.celular}
												onChange={(e: any) =>
													setCadastro({ ...cadastro, celular: e.target.value })
												}
											>
												{() => <Form.Control type="text" />}
											</InputMask>
										</Form.Group>

										<Form.Group controlId="sexo" className="custom-form-group">
											<Form.Label className="custom-label">Sexo</Form.Label>
											<Form.Control
												as="select"
												value={cadastro.sexo}
												onChange={(e) =>
													setCadastro({ ...cadastro, sexo: e.target.value })
												}
											>
												<option value="">Selecione</option>
												<option value="M">Masculino</option>
												<option value="F">Feminino</option>
											</Form.Control>
										</Form.Group>
									</div>
									<div className="aso-botoes-finalizar-cad">
										<Button
											variant="secondary"
											className="aso-btn-mp"
											onClick={handleVoltarAoGeral}
										>
											Voltar
										</Button>
										<Button
											variant="primary"
											className="aso-btn-mp"
											onClick={() => {
												setCadastro((prev) => ({
													...prev,
													versoRGValidado: true,
												}));
												handleVoltarAoGeral();
											}}
										>
											Salvar
										</Button>
									</div>
								</Card.Body>
							</Card>
						)}
					</div>
				</div>
			)}
			<AlertMessage
				show={alert.show}
				message={alert.message}
				variant={alert.variant}
				onClose={() => setAlert({ ...alert, show: false })}
			/>
		</>
	);
};

export default AsoValidarInfoReaproveitamento;
